<div ngbDropdown placement="bottom-end" class="topbar-item dropdown">
    <!-- Toggle -->
    <button class="topbar-link drop-arrow-none" ngbDropdownToggle aria-expanded="false">
        <lucide-angular [img]="LayoutGrid" class="fs-xxl"></lucide-angular>
    </button>

    <!-- Dropdown -->
    <div ngbDropdownMenu class="dropdown-menu-lg p-2 dropdown-menu-end">
        <div class="row align-items-center g-1">

            @for (app of apps; track app.name) {
                <div class="col-4">
                    <a href="javascript:void(0)" class="dropdown-item border border-dashed rounded text-center py-2">
            <span class="avatar-sm d-block mx-auto mb-1">
              @if (app.type === 'img') {
                  <span class="avatar-title text-bg-light rounded-circle">
                  <img [src]="app.icon" [alt]="app.name" width="18" height="18" />
                </span>
              }
                @if (app.type === 'icon') {
                    <span class="avatar-title bg-primary-subtle text-primary rounded-circle">
                  <ng-icon [name]="app.icon" size="18"></ng-icon>
                </span>
                }
            </span>
                        <span class="fw-medium">{{ app.name }}</span>
                    </a>
                </div>
            }

            <!-- Plus button -->
            <div class="col-4 text-center">
                <button class="btn btn-danger btn-sm rounded-circle btn-icon">
                    <ng-icon name="tablerCirclePlus" size="18"></ng-icon>
                </button>
            </div>
        </div>
    </div>
</div>
